import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
import { TermsType, goRecentTerms } from 'src/utils/terms/zendeskApi';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  position: fixed;
  color: ${({
  theme
}) => theme.color.content7};
`;
const TermsView = () => {
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;
    const query = router.query;
    const lang = Array.isArray(query.lang) ? query.lang[0] : query.lang;
    goRecentTerms(TermsType.termsOfService, lang);
  }, [router.isReady, router.query]);
  return <LoadingIndicator size={32} data-sentry-element="LoadingIndicator" data-sentry-component="TermsView" data-sentry-source-file="Terms.tsx" />;
};
export default TermsView;